import { computeCoverageReport, registryOnlyBlockKeys } from '@web-studio/layout-matrix';
import { Link } from 'react-router-dom';

export function CoveragePage() {
  const report = computeCoverageReport();
  const registryOnly = registryOnlyBlockKeys();

  return (
    <div className="lab-page">
      <header className="lab-page-header">
        <h1 className="lab-page-header__title">Coverage</h1>
        <p className="lab-page-header__desc">
          Implementation vs theme matrix · {report.registryOnlyBlocks} registry-only block keys
        </p>
      </header>

      <table className="lab-table">
        <thead>
          <tr>
            <th>Component</th>
            <th>Registry key</th>
            <th>Fixtures</th>
            <th>Rendered cells</th>
            <th>Total cells</th>
            <th>Verticals</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {report.rows.map((row) => (
            <tr key={row.componentType}>
              <td>
                <code>{row.componentType}</code>
              </td>
              <td>
                <code>{row.registryKey}</code>
              </td>
              <td>{row.fixtureCount}</td>
              <td>{row.themeCellsRendered}</td>
              <td>{row.themeCellsTotal}</td>
              <td>{row.verticals.join(', ')}</td>
              <td>
                <Link
                  to={`/matrix/block/${row.componentType}`}
                  className="text-xs no-underline"
                  style={{ color: 'var(--lab-accent)' }}
                >
                  Isolate
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <section>
        <h2 className="text-sm font-semibold">Registry-only blocks</h2>
        <ul className="mt-2 columns-2 gap-4 text-xs" style={{ color: 'var(--lab-muted)' }}>
          {registryOnly.map((key) => (
            <li key={key}>
              <code>{key}</code>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
